import React from 'react';
import styled from 'styled-components';

import { TableHead, TableRow, ThItem } from '@/component-style/Table';

const THead = styled(TableHead)`
  min-width: 920px;
`;

const Th80 = styled(ThItem)`
  width: 80px;
`;

const Th120 = styled(ThItem)`
  width: 120px;
`;

const Th160 = styled(ThItem)`
  width: 160px;
`;

const Header = () => {
  
  return (
    <THead>
      <TableRow>
        <Th120>所屬公司</Th120>
        <Th120>專案代號</Th120>
        <Th160>專案名稱</Th160>
        <Th120>活動日期</Th120>
        <Th80>財務狀況</Th80>
        <Th80>報價</Th80>
        <Th80>核可</Th80>
        <Th80>請款</Th80>
        <Th80>入帳</Th80>
      </TableRow>
    </THead>
  );
};

export default Header;
